import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalCloseButton,
  Box,
  Text,
  Button,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import ForecastDashboard from "./ForecastDashboard";
import AdvancedForecastView from "./AdvancedForecastView";
import CashForecasting from "./CashForecasting";
import DistributionForecasting from "./DistributionForecasting";
import AnalysisForecasting from "./AnalysisForecasting";
import TradingBalanceForecasting from "./TradingBalanceForecasting";
interface ForecastDashboardModel {
  isOpen: boolean;
  onClose: () => void;
}

const ForecastDashboardModel: React.FC<ForecastDashboardModel> = ({
  isOpen,
  onClose,
}) => {
  const [viewMode, setViewMode] = useState<
    | "select"
    | "inventory"
    | "cash"
    | "advanced"
    | "distribution"
    | "analysis"
    | "trading"
  >("select");

  const goBackToSelection = () => setViewMode("select");

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody p={6}>
          {viewMode === "select" && (
            <>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                Select Forecasting Model
              </Text>
              <Flex gap={6} flexWrap="wrap" justify="center">
                <Box
                  p={6}
                  borderWidth={1}
                  borderRadius="md"
                  shadow="md"
                  cursor="pointer"
                  bg="white"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => setViewMode("inventory")}
                >
                  <Text fontSize="xl" fontWeight="semibold">
                    📦 Inventory Forecasting
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Forecast product quantities
                  </Text>
                </Box>
                <Box
                  p={6}
                  borderWidth={1}
                  borderRadius="md"
                  shadow="md"
                  cursor="pointer"
                  bg="white"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => setViewMode("cash")}
                >
                  <Text fontSize="xl" fontWeight="semibold">
                    💰 Cash Forecasting
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Predict weekly cash flow
                  </Text>
                </Box>
                <Box
                  p={6}
                  borderWidth={1}
                  borderRadius="md"
                  shadow="md"
                  cursor="pointer"
                  bg="white"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => setViewMode("distribution")}
                >
                  <Text fontSize="xl" fontWeight="semibold">
                    📦 Distribution Forecasting
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Forecast volume, delivery, returns, and cost
                  </Text>
                </Box>
                <Box
                  p={6}
                  borderWidth={1}
                  borderRadius="md"
                  shadow="md"
                  cursor="pointer"
                  bg="white"
                  _hover={{ bg: "gray.100" }}
                  onClick={() => setViewMode("trading")}
                >
                  <Text fontSize="xl" fontWeight="semibold">
                    📊 Trading Balance Forecast
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    Predict trading balance at any specific time
                  </Text>
                </Box>
              </Flex>
              <Box mt={6} textAlign="center">
                <Button
                  variant="link"
                  colorScheme="blue"
                  onClick={() => setViewMode("advanced")}
                >
                  View Advanced Forecasting
                </Button>
              </Box>
              <Box mt={6} textAlign="center">
                <Button
                  variant="link"
                  colorScheme="blue"
                  onClick={() => setViewMode("analysis")}
                >
                  Analysis inventory forecasting
                </Button>
              </Box>
            </>
          )}

          {viewMode === "inventory" && (
            <ForecastDashboard
              onClose={onClose}
              onOpenAdvanced={() => setViewMode("select")}
            />
          )}
          {viewMode === "analysis" && (
            <AnalysisForecasting
              onClose={onClose}
              onOpenAdvanced={() => setViewMode("select")}
            />
          )}
          {viewMode === "trading" && (
            <TradingBalanceForecasting
              onClose={onClose}
              onOpenAdvanced={() => setViewMode("select")}
            />
          )}

          {viewMode === "cash" && (
            <CashForecasting
              onClose={onClose}
              onOpenAdvanced={() => setViewMode("select")}
            />
          )}
          {viewMode === "distribution" && (
            <DistributionForecasting
              onClose={onClose}
              onOpenAdvanced={() => setViewMode("select")}
            />
          )}
          {viewMode === "advanced" && (
            <AdvancedForecastView onClose={goBackToSelection} />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ForecastDashboardModel;
